import { SignupState, defaultSignupState, signupForm } from "./state";
import { Action } from "redux";
import { changeStatusSignupModalAction, changeSignupSendingFlag } from "./actions";

export function signupReducer(state: SignupState = defaultSignupState, action: Action): SignupState {
    if (signupForm.actions.isMyAction(action)) {
        return {
            ...state,
            signupForm: signupForm.reducer(state.signupForm, action)
        };
    }

    if (changeStatusSignupModalAction.is(action)) {
        return {
            ...state,
            isOpenSignup: action.isOpen,
            signupForm: signupForm.state.empty()
        };
    }

    if (changeSignupSendingFlag.is(action)) {
        return {
            ...state,
            signupSendingFlag: action.status
        };
    }

    return state;
}
